// src/App.js
import React from "react";

function Success() {
  return <div>Başarılı</div>;
}

export default Success;
